module.exports = __webpack_public_path__ + "static/media/hydroponics_systems_dutch_bucket4.500bb4fd.webp";